import { useParams } from 'react-router-dom';

import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { useMatchingRoutes } from '@/hooks/useMatchingRoutes';
import { CreateNewEntityOrStrategy } from '@/modules/common/CreateNewEntityOrStrategy/CreateNewEntityOrStrategy';
import { EstateWaterfallActionButtons } from '@/modules/estateWaterfall/components/EstateWaterfallActionButtons/EstateWaterfallActionButtons';
import { ROUTE_KEYS } from '@/navigation/constants';

interface ClientDetailsPageActionItemsProps {
  householdId: string;
}

const WATERFALL_ROUTES = [
  ROUTE_KEYS.HOUSEHOLD_DETAILS_ESTATE_WATERFALL_TAB,
  ROUTE_KEYS.HOUSEHOLD_DETAILS_ESTATE_WATERFALL_TAB_DIAGRAM,
  ROUTE_KEYS.HOUSEHOLD_DETAILS_ESTATE_WATERFALL_TAB_SUMMARY,
  ROUTE_KEYS.HOUSEHOLD_DETAILS_ESTATE_WATERFALL_TAB_LIST,
  ROUTE_KEYS.HOUSEHOLD_DETAILS_ESTATE_WATERFALL_TAB_SUMMARY_ESTATE_TAX_CALCULATION_TROWSER,
];

const DISPOSITION_ROUTES = [
  ROUTE_KEYS.HOUSEHOLD_ESTATE_MANAGE_DISPOSITIONS,
  ROUTE_KEYS.HOUSEHOLD_ESTATE_MANAGE_DISPOSITIONS_ESTATE_TAX_CALCULATION_TROWSER,
];
// This component is used to render the action items on the client details page.
// The spacing between them is set on the parent component.
export function ClientDetailsPageActionItems({
  householdId,
}: ClientDetailsPageActionItemsProps) {
  const { isMatchingRoute: isWaterfallRoute } =
    useMatchingRoutes(WATERFALL_ROUTES);

  const { isMatchingRoute: isDispositionsRoute } =
    useMatchingRoutes(DISPOSITION_ROUTES);

  const waterfallId = useParams().waterfallId ?? null;
  const { navigate } = useNavigateToRoute();
  const onAfterCreate = () => {
    navigate(ROUTE_KEYS.HOUSEHOLD_DETAILS_PEOPLE_ORGANIZATIONS, {
      householdId,
    });
  };

  if (isDispositionsRoute) {
    return null;
  }

  if (isWaterfallRoute) {
    return (
      <EstateWaterfallActionButtons
        householdId={householdId}
        waterfallId={waterfallId}
      />
    );
  }

  return (
    <>
      <CreateNewEntityOrStrategy
        size="sm"
        householdId={householdId}
        onAfterCreateIndividualOrOrganization={onAfterCreate}
      />
    </>
  );
}
